import React, { useCallback } from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import classNames from 'classnames';

import 'react-phone-input-2/lib/style.css';
import './phoneInput.scss';

export const PhoneInput = (props) => {
  const { label, value, placeholder, onChange, type = 'text', errorMessage = '' } = props;

  const inputStyles = classNames('phone-input', {
    'phone-input--error': errorMessage,
  });

  const onChangeInput = useCallback(
    (phone) => {
      onChange({ target: { value: phone } });
    },
    [onChange],
  );

  return (
    <div className="phone-input-wrapper">
      <label className="phone-input-label" htmlFor={label}>
        {label}
      </label>
      <ReactPhoneInput
        country={'us'}
        className={inputStyles}
        id={label}
        value={value}
        placeholder={placeholder}
        onChange={onChangeInput}
      />
      {errorMessage && <div className="phone-input-error-message">* {errorMessage}</div>}
    </div>
  );
};
